import { demoFile, componentWithVariants, variant, component, feature } from 'system/demo';
import { ThoughtProvokingPrompt, ThoughtProvokingPromptHistory, ThoughtProvokingPromptHistoryItem } from 'open-modules/zdf/feature/conversation-helper';
import { ConversationHelperAdminScreen } from 'open-modules/zdf/feature/conversation-helper';
import { AutoModeratorReactionTypesWidget } from 'open-modules/zdf/component/conversationhelper/autoModeratorReactions';
import { colorTextPrimaryOnLightColorBg } from 'component/color';
import { t } from "util/stdtypes";

const conversationHelperDemoData = {
    globals: { name: 'Demo question' },
    comments: [],
    thoughtProvokingPrompts: [
        { key: 't1', suggestedPerspective: 'Be nice', reminder: 'Be kind', time: Date.now() },
        { key: 't2', suggestedPerspective: 'Share ideas', reminder: 'Keep it civil', time: Date.now() - 1000 }
    ],
    reactions: [],
    reactionTypes: [
        { label: t('Thank you'), emoji: '🙏' },
        { label: t('Disagree'), emoji: '🤔' }
    ],
    summaries: [],
    serverCalls: {}
};

demoFile('open-modules/zdf/feature/conversation-helper');

const baseState = {
    collections: {
        thought_provoking_prompt: conversationHelperDemoData.thoughtProvokingPrompts,
        thought_provoking_prompt_reactions: conversationHelperDemoData.reactions,
        summary: conversationHelperDemoData.summaries,
    },
};

componentWithVariants('ThoughtProvokingPrompt', ThoughtProvokingPrompt, {
    args: { currentThoughtProvokingPrompt: conversationHelperDemoData.thoughtProvokingPrompts[0] },
    state: baseState,
}, [
    variant(null, { config: { conversationHelperReactionTypes: conversationHelperDemoData.reactionTypes } }),
    variant('With reactions', { config: { conversationHelperReactionTypes: conversationHelperDemoData.reactionTypes, reactionsEnabled: true } }),
    variant('With history', { config: { conversationHelperReactionTypes: conversationHelperDemoData.reactionTypes, historyEnabled: true } }),
    variant('With summary', { config: { conversationHelperReactionTypes: conversationHelperDemoData.reactionTypes, summaryEnabled: true } }),
]);

component('ThoughtProvokingPromptHistory', ThoughtProvokingPromptHistory, {
    state: {
        collections: { thought_provoking_prompt: conversationHelperDemoData.thoughtProvokingPrompts },
    },
});


component('ThoughtProvokingPromptHistoryItem', ThoughtProvokingPromptHistoryItem, {
    args: { thoughtProvokingPrompt: conversationHelperDemoData.thoughtProvokingPrompts[0] },
    state: {
        collections: { thought_provoking_prompt_reactions: conversationHelperDemoData.reactions },
    },
    config: { conversationHelperReactionTypes: conversationHelperDemoData.reactionTypes },
});


component('AutoModeratorReactionTypesWidget', AutoModeratorReactionTypesWidget, {
    args: { thoughtProvokingPrompt: conversationHelperDemoData.thoughtProvokingPrompts[0] },
    state: {
        collections: { 
            thought_provoking_prompt_reactions: conversationHelperDemoData.reactions,
            thought_provoking_prompt: conversationHelperDemoData.thoughtProvokingPrompts,
        },
    },
    config: { conversationHelperReactionTypes: conversationHelperDemoData.reactionTypes },
});

component('ConversationHelperAdminScreen', ConversationHelperAdminScreen, {
    state: {
        globals: conversationHelperDemoData.globals,
        roles: ['Moderator'],
        collections: {
            thought_provoking_prompt: conversationHelperDemoData.thoughtProvokingPrompts,
            thought_provoking_prompt_reactions: conversationHelperDemoData.reactions,
            comment: conversationHelperDemoData.comments,
        },
        serverCall: conversationHelperDemoData.serverCalls,
    },
    config: { reactionTypes: conversationHelperDemoData.reactionTypes, conversationHelperTextColor: colorTextPrimaryOnLightColorBg },
});

feature('conversationhelper', {
    structureKey: 'question',
    state: {
        globals: conversationHelperDemoData.globals,
        collections: {
            comment: conversationHelperDemoData.comments,
            thought_provoking_prompt: conversationHelperDemoData.thoughtProvokingPrompts,
        },
        serverCall: conversationHelperDemoData.serverCalls,
        roles: ['Moderator'],
    },
});
